import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/participantes-entregas";

const getParticipantesEntregas = async (proyectos = []) => {
  const params = {};
  if (proyectos.length > 0) {
    params.proyectos = proyectos.join(",");
  }
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params
  });
  return response.data;
};

export {
  getParticipantesEntregas
};